import React, { ReactElement } from 'react';

import displayValues from '../../resources/displayValues.json';
import { HotelOffer } from '../../interfaces';

export type HotelResultItemMiscProps = Pick<HotelOffer, 'board' | 'roomDescription'>;

const mealsDisplayValues = displayValues.amenities.meals as Record<string, string>;

export const HotelResultItemMisc: React.FC<HotelResultItemMiscProps> = ({
    board,
    roomDescription,
}): ReactElement<HotelResultItemMiscProps> => (
    <>
        <div className="flex flex__row flex__justify_left u-pv4">
            <span className="icon-pre icon--two-adults" />
            <div>2 Voksne</div>
        </div>
        <div className="flex flex__row flex__justify_left u-pv4">
            <span className="icon-pre icon--bed-big " />
            <div data-testid="roomDescription">{roomDescription}</div>
        </div>
        {board && (
            <div className="icon-pre icon--knife-fork flex u-pv4" data-testid="boardInfo">
                {mealsDisplayValues[board]}
            </div>
        )}
    </>
);
